import { render, staticRenderFns } from "./MessagesListItemPlaceholder.vue?vue&type=template&id=8a0d9dd4&scoped=true"
var script = {}
import style0 from "./MessagesListItemPlaceholder.vue?vue&type=style&index=0&id=8a0d9dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0d9dd4",
  null
  
)

export default component.exports